import React, { useState, useEffect } from "react";
import axios from "axios";

export default function ContactSection({ registerIntent }) {

  // ── Form state ──────────────────────────────────────────────────────────
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitted,    setSubmitted]    = useState(false);
  const [form, setForm] = useState({
    name:     "",
    email:    "",
    phone:    "",
    business: "",
    message:  "",
    file:     null,
    website:  "", // honeypot
  });

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setForm(prev => ({ ...prev, [name]: files ? files[0] : value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Bot protection — honeypot filled = bot
    if (form.website) return;

    setIsSubmitting(true);

    try {
      const payload = new FormData();
      payload.append("name",    form.name);
      payload.append("email",   form.email);
      payload.append("phone",   form.phone);
      payload.append("company", form.business);
      payload.append("message", form.message);
      if (form.file) payload.append("document", form.file);

      const response = await axios.post(
        "https://devdigital.exdnow.com/digital-api/extra.php",
        payload,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      if (response.data.response_code == 200) {
        setSubmitted(true);
        setForm({ name:"", email:"", phone:"", business:"", message:"", file:null, website:"" });
        setTimeout(() => setSubmitted(false), 4000);
      } else {
        alert("Error sending message. Please try again.");
      }
    } catch (err) {
      alert("Error sending message. Please try again.");
      console.log(err);
    } finally {
      setIsSubmitting(false);
    }
  };

  // ── Register scroll intent — no internal steps ──────────────────────────
  useEffect(() => {
    if (!registerIntent) return;
    registerIntent(() => false);
  }, [registerIntent]);

  return (
    <section id="contact-section" className="cs">

      {/* Subtle grid */}
      <div className="cs__grid" />

      {/* ── LEFT: tagline ── */}
      <div className="cs__left">
        {/* <div className="cs__left-tag">
          <span className="cs__pip" />
          Contact Us
        </div> */}
        <h2 className="cs__heading">
          Let's build<br />
          something<br />
          <span className="cs__heading-grad">great together</span>
        </h2>
        {/* <div className="cs__contact-info">
          <p className="cs__contact-label">Contact Us</p>
          <a href="mailto:digital@exdnow.com" className="cs__contact-email">
            digital@exdnow.com
          </a>
        </div> */}
      </div>

      {/* ── CENTER: form card ── */}
      <div className="cs__center">
        <div className="cs__card">
          <div className="cs__card-border" />

          <div className="cs__card-inner">
            <h3 className="cs__form-title">Book A Call</h3>
            {/* <div className="cs__contact-info-mobile">
                <p className="cs__contact-label-mobile">Contact Us</p>
                <a href="mailto:digital@exdnow.com" className="cs__contact-email-mobile">
                    digital@exdnow.com
                </a>
            </div> */}
            <p className="cs__form-sub">
              Fill in your details and tell us a little about what you are working
              on. Our team will review your requirements and get back to you within
              1 business day with the next steps.
            </p>

            {submitted ? (
              <div className="cs__success">
                <div className="cs__success-icon">✓</div>
                <p>Thank you! We'll be in touch within 1 business day.</p>
              </div>
            ) : (
              <form className="cs__form" onSubmit={handleSubmit}>

                <div className="cs__row">
                  <div className="cs__field">
                    <label>Name*</label>
                    <input
                      type="text" name="name" required
                      value={form.name} onChange={handleChange}
                      placeholder="Your full name"
                    />
                  </div>
                  <div className="cs__field">
                    <label>Official Email*</label>
                    <input
                      type="email" name="email" required
                      value={form.email} onChange={handleChange}
                      placeholder="you@company.com"
                    />
                  </div>
                </div>

                <div className="cs__row">
                  <div className="cs__field">
                    <label>Phone Number*</label>
                    <input
                      type="tel" name="phone" required
                      value={form.phone} onChange={handleChange}
                      placeholder="+1 234 567 8900"
                    />
                  </div>
                  <div className="cs__field">
                    <label>Business Name*</label>
                    <input
                      type="text" name="business" required
                      value={form.business} onChange={handleChange}
                      placeholder="Your company"
                    />
                  </div>
                </div>

                <div className="cs__field cs__field--full">
                  <label>Message*</label>
                  <textarea
                    name="message" required rows={3}
                    value={form.message} onChange={handleChange}
                    placeholder="Tell us about your project..."
                  />
                </div>

                <div className="cs__field cs__field--full">
                  <label>Requirement document (if any)</label>
                  <div className="cs__file-wrap">
                    <label className="cs__file-btn">
                      <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                        <path d="M7 1v8M4 4l3-3 3 3M2 10h10v2H2z"
                          stroke="currentColor" strokeWidth="1.3"
                          strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                      Choose File
                      <input
                        type="file" name="file" hidden
                        onChange={handleChange}
                        accept=".pdf,.doc,.docx,.txt"
                      />
                    </label>
                    <span className="cs__file-name">
                      {form.file ? form.file.name : "No file chosen"}
                    </span>
                  </div>
                </div>

                {/* Honeypot — invisible to real users, catches bots */}
                <input
                  type="text"
                  name="website"
                  value={form.website}
                  onChange={handleChange}
                  tabIndex="-1"
                  autoComplete="off"
                  aria-hidden="true"
                  style={{ position:"absolute", left:"-9999px", height:"0", width:"0", overflow:"hidden" }}
                />

                <button
                  type="submit"
                  className={`cs__submit ${isSubmitting ? "cs__submit--inactive" : ""}`}
                  disabled={isSubmitting}
                >
                  {isSubmitting ? (
                    <><span className="cs__spinner" /> Sending...</>
                  ) : "Submit"}
                </button>

              </form>
            )}
          </div>
        </div>

        {/* ── Badge: circular rotating text using CSS divs only ── */}
        <div className="cs__right">
          <div className="cs__badge-wrap">
            {/* Rotating ring of letters */}
            <div className="cs__badge-ring">
          <span className="cs__letter" style={{transform: "rotate(0.0deg) translateY(-52px)"}}>{"B"}</span>
          <span className="cs__letter" style={{transform: "rotate(11.25deg) translateY(-52px)"}}>{"O"}</span>
          <span className="cs__letter" style={{transform: "rotate(22.5deg) translateY(-52px)"}}>{"O"}</span>
          <span className="cs__letter" style={{transform: "rotate(33.75deg) translateY(-52px)"}}>{"K"}</span>
          <span className="cs__letter" style={{transform: "rotate(45.0deg) translateY(-52px)"}}>{" "}</span>
          <span className="cs__letter" style={{transform: "rotate(56.25deg) translateY(-52px)"}}>{"A"}</span>
          <span className="cs__letter" style={{transform: "rotate(67.5deg) translateY(-52px)"}}>{" "}</span>
          <span className="cs__letter" style={{transform: "rotate(78.75deg) translateY(-52px)"}}>{"C"}</span>
          <span className="cs__letter" style={{transform: "rotate(90.0deg) translateY(-52px)"}}>{"A"}</span>
          <span className="cs__letter" style={{transform: "rotate(101.25deg) translateY(-52px)"}}>{"L"}</span>
          <span className="cs__letter" style={{transform: "rotate(112.5deg) translateY(-52px)"}}>{"L"}</span>
          <span className="cs__letter" style={{transform: "rotate(123.75deg) translateY(-52px)"}}>{" "}</span>
          <span className="cs__letter" style={{transform: "rotate(135.0deg) translateY(-52px)"}}>{" "}</span>
          <span className="cs__letter" style={{transform: "rotate(146.25deg) translateY(-52px)"}}>{"·"}</span>
          <span className="cs__letter" style={{transform: "rotate(157.5deg) translateY(-52px)"}}>{" "}</span>
          <span className="cs__letter" style={{transform: "rotate(168.75deg) translateY(-52px)"}}>{" "}</span>
          <span className="cs__letter" style={{transform: "rotate(180.0deg) translateY(-52px)"}}>{"B"}</span>
          <span className="cs__letter" style={{transform: "rotate(191.25deg) translateY(-52px)"}}>{"O"}</span>
          <span className="cs__letter" style={{transform: "rotate(202.5deg) translateY(-52px)"}}>{"O"}</span>
          <span className="cs__letter" style={{transform: "rotate(213.75deg) translateY(-52px)"}}>{"K"}</span>
          <span className="cs__letter" style={{transform: "rotate(225.0deg) translateY(-52px)"}}>{" "}</span>
          <span className="cs__letter" style={{transform: "rotate(236.25deg) translateY(-52px)"}}>{"A"}</span>
          <span className="cs__letter" style={{transform: "rotate(247.5deg) translateY(-52px)"}}>{" "}</span>
          <span className="cs__letter" style={{transform: "rotate(258.75deg) translateY(-52px)"}}>{"C"}</span>
          <span className="cs__letter" style={{transform: "rotate(270.0deg) translateY(-52px)"}}>{"A"}</span>
          <span className="cs__letter" style={{transform: "rotate(281.25deg) translateY(-52px)"}}>{"L"}</span>
          <span className="cs__letter" style={{transform: "rotate(292.5deg) translateY(-52px)"}}>{"L"}</span>
          <span className="cs__letter" style={{transform: "rotate(303.75deg) translateY(-52px)"}}>{" "}</span>
          <span className="cs__letter" style={{transform: "rotate(315.0deg) translateY(-52px)"}}>{" "}</span>
          <span className="cs__letter" style={{transform: "rotate(326.25deg) translateY(-52px)"}}>{"·"}</span>
          <span className="cs__letter" style={{transform: "rotate(337.5deg) translateY(-52px)"}}>{" "}</span>
          <span className="cs__letter" style={{transform: "rotate(348.75deg) translateY(-52px)"}}>{" "}</span>
            </div>
            {/* Center circle */}
            <div className="cs__badge-center">
              <div className="cs__badge-dot" />
            </div>
          </div>
        </div>
      </div>


    </section>
  );
}